import {
    SOLICITO_INFORMACION_EJERCICIO_EXITO,
    SOLICITO_INFORMACION_PACIENTE_EXITO,
    CAMBIAR_ARCHIVADO_PACIENTE_EXITO,
    SOLICITAR_OBJETIVOS_EXITO,
    MODIFICAR_OBJETIVO_EXITO,
    SOLICITO_ANAMNESIS_EXITO,
    SOLICITAR_HISTORIA_CLINICA_EXITO,
    MODIFICAR_HISTORIA_CLINICA_EXITO,
    SOLICITAR_ACTIVIDADES_EXITO,
    SOLICITAR_ACTIVIDADES_AGENDADAS_EXITO,
    ACTUALIZAR_INFO_ACTIVIDADES_EXITO,
    ACTUALIZAR_INFORMACION_PACIENTE_EXITO,
    ESTADO_PACIENTE_INITIAL,
    ESTADO_USUARIO_PACIENTE_INITIAL,
    CERRAR_SESION,
    RESET_EJERCICIO,
    CONSULTAR_ACTIVIDADES_RESULTADOS_SUCCESS,
    CONSULTAR_EJERCICIOS_RESULTADOS_SUCCESS,
    MODIFICAR_PACIENTES,
    ALMACENAR_CHECK_EJERCICIO_EXITO,
    BORRAR_INFO_DB,
    SOLICITO_INFORMACION_TURNOS_EXITO,
    CREAR_TURNO_EXITO,
    EDITAR_TURNO_EXITO,
    BORRAR_TURNO_EXITO,
    REENVIAR_NOTIFICACION_TURNO_EXITO,

    /*
    ====================================
    ANAMNESIS - ENTREVISTA
    ====================================
    */

    SOLICITAR_ANAMNESIS_ENTREVISTA,
    SOLICITAR_ANAMNESIS_ENTREVISTA_EXITO,
    SOLICITAR_ANAMNESIS_ENTREVISTA_ERROR,
    ALMACENAR_ANAMNESIS_ENTREVISTA,
    ALMACENAR_ANAMNESIS_ENTREVISTA_EXITO,
    ALMACENAR_ANAMNESIS_ENTREVISTA_ERROR,

    /*
    ====================================
    ANAMNESIS - ADENDAS
    ====================================
    */

    SOLICITAR_ADENDAS_ANAMNESIS,
    SOLICITAR_ADENDAS_ANAMNESIS_EXITO,
    SOLICITAR_ADENDAS_ANAMNESIS_ERROR,
    ALMACENAR_ADENDA_ANAMNESIS,
    ALMACENAR_ADENDA_ANAMNESIS_EXITO,
    ALMACENAR_ADENDA_ANAMNESIS_ERROR,

    /*
    ====================================
    EXPORTACIÓN HISTORIA CLÍNICA
    ====================================
    */

    SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES,
    SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES_EXITO,
    SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES_ERROR,
    PREPARAR_EXPORTACION_HISTORIA_CLINICA,
    PREPARAR_EXPORTACION_HISTORIA_CLINICA_EXITO,
    PREPARAR_EXPORTACION_HISTORIA_CLINICA_ERROR,
    EXPORTAR_HISTORIAS_CLINICAS,
    EXPORTAR_HISTORIAS_CLINICAS_EXITO,
    EXPORTAR_HISTORIAS_CLINICAS_ERROR

} from '../types';


/*
====================================
ESTADO INICIAL
====================================
*/

const initialState = {

    info_DB: [],

    lista_pacientes: [],

    lista_ejercicios_check: [],

    lista_usada: [],

    info_anamnesis: [],


    /*
    ====================================
    ANAMNESIS - ENTREVISTA
    ====================================
    */

    info_anamnesis_entrevista: null,

    anamnesis_entrevista_cargando: false,

    anamnesis_entrevista_cargada: false,

    anamnesis_entrevista_guardando: false,

    anamnesis_entrevista_error: null,


    /*
    ====================================
    ANAMNESIS - ADENDAS
    ====================================
    */

    info_anamnesis_adendas: [],

    anamnesis_adendas_paciente_id: null,

    anamnesis_adendas_cargando: false,

    anamnesis_adendas_cargadas: false,

    anamnesis_adendas_guardando: false,

    anamnesis_adendas_error: null,


    /*
    ====================================
    OTROS DATOS
    ====================================
    */

    info_objetivos: [],

    info_historia_clinica: [],

    /*
    ====================================
    EXPORTACIÓN HISTORIA CLÍNICA
    ====================================
    */

    info_historias_clinicas_exportables: {

        scope:
            null,

        pacientes:
            []

    },

    historias_clinicas_exportables_cargando:
        false,

    historias_clinicas_exportables_error:
        null,

    preparacion_exportacion_hc:
    null,

    preparacion_exportacion_hc_cargando:
        false,

    preparacion_exportacion_hc_error:
        null,

    exportacion_historias_clinicas_cargando:
        false,

    exportacion_historias_clinicas_error:
        null,

    exportacion_historias_clinicas_resultado:
        null,

    info_actividades: [],

    info_actividades_agendadas: [],

    info_resultados: [],

    info_resultadosDos: [],

    info_calendario: []

};


/*
----------------------------------------------------
HELPERS TURNOS / CALENDARIO
----------------------------------------------------
*/

const getTurnoId = (turno) => {

    return turno?.id_turno || turno?.id;

};


const normalizeRepeatValue = (repeatValue) => {

    if (repeatValue === 'semanalmente') {

        return 'semanal';

    }


    if (repeatValue === 'quincenalmente') {

        return 'quincenal';

    }


    return repeatValue || 'no';

};


const normalizeModalidadTurno = (modalidad) => {

    if (modalidad === 'virtual') {

        return 'virtual';

    }


    return 'presencial';

};


const normalizarTurnoFront = (turno) => {

    if (!turno) {

        return null;

    }


    const pacienteNombreCompleto =
        turno.paciente_nombre_completo ||
        `${turno.paciente_nombre || ''} ${turno.paciente_apellido || ''}`.trim() ||
        'Paciente sin nombre';


    const repeatNormalizado = normalizeRepeatValue(

        turno.repeat_type ||
        turno.repeat ||
        turno.repetir_turno ||
        turno.tipo_repeticion ||
        'no'

    );


    const modalidadTurno = normalizeModalidadTurno(

        turno.modalidad_turno ||
        turno.modalidad ||
        'presencial'

    );


    const telefonoConsultorio =

        turno.telefono_consultorio ||
        turno.telefono_contacto ||
        '';


    const incluirTelefonoConsultorio =

        turno.incluir_telefono_consultorio ||
        turno.incluir_telefono ||
        (telefonoConsultorio ? 'si' : 'no');


    return {

        ...turno,


        id: turno.id || turno.id_turno,

        id_turno: turno.id_turno || turno.id,


        id_paciente: turno.id_paciente || '',

        paciente_id:
            turno.paciente_id ||
            turno.id_paciente ||
            '',


        paciente_nombre: turno.paciente_nombre || '',

        paciente_apellido: turno.paciente_apellido || '',

        paciente_nombre_completo: pacienteNombreCompleto,


        fecha_turno: turno.fecha_turno || '',

        hora_inicio: turno.hora_inicio || '',

        hora_fin: turno.hora_fin || '',


        estado: turno.estado || 'PENDIENTE',

        comentario: turno.comentario || '',

        link_reunion: turno.link_reunion || '',

        honorarios: turno.honorarios ?? '',


        repeat: repeatNormalizado,

        repeat_type: repeatNormalizado,

        repeat_group_id: turno.repeat_group_id || null,


        es_parte_serie:
            Boolean(
                turno.es_parte_serie ||
                turno.repeat_group_id
            ),

        es_turno_original_serie:
            Boolean(turno.es_turno_original_serie),

        puede_modificar_condiciones_serie:
            Boolean(
                turno.puede_modificar_condiciones_serie
            ),


        serie_fecha_origen:
            turno.serie_fecha_origen || null,

        serie_hora_inicio_origen:
            turno.serie_hora_inicio_origen || null,


        fecha_notificacion:
            turno.fecha_notificacion || '',

        notificar:
            turno.notificar || 'no',

        notificar_cantidad:
            turno.notificar_cantidad ?? 0,

        email_1:
            turno.email_1 || '',

        email_2:
            turno.email_2 || '',


        estado_notificacion:
            turno.estado_notificacion ||
            'SIN_NOTIFICACION',

        motivo_error_notificacion:
            turno.motivo_error_notificacion || null,


        modalidad_turno:
            modalidadTurno,


        direccion_consultorio:

            modalidadTurno === 'presencial'
                ? turno.direccion_consultorio || ''
                : '',


        incluir_telefono_consultorio:

            incluirTelefonoConsultorio === 'si'
                ? 'si'
                : 'no',


        telefono_consultorio:

            incluirTelefonoConsultorio === 'si'
                ? telefonoConsultorio
                : '',


        cola_email_turnos:

            Array.isArray(turno.cola_email_turnos)
                ? turno.cola_email_turnos
                : []

    };

};


const agregarTurnosSinDuplicar = (
    turnosActuales = [],
    turnosNuevos = []
) => {

    const nuevosNormalizados = turnosNuevos
        .map(normalizarTurnoFront)
        .filter(Boolean);


    const idsNuevos = nuevosNormalizados
        .map(getTurnoId)
        .map(String);


    const turnosFiltrados = turnosActuales.filter(
        (turnoActual) => {

            const idActual =
                getTurnoId(turnoActual);

            return !idsNuevos.includes(
                String(idActual)
            );

        }
    );


    return [

        ...turnosFiltrados,

        ...nuevosNormalizados

    ];

};


const reemplazarTurnos = (
    turnosActuales = [],
    turnosActualizados = []
) => {

    const actualizadosNormalizados =
        turnosActualizados
            .map(normalizarTurnoFront)
            .filter(Boolean);


    const mapaActualizados = new Map();


    actualizadosNormalizados.forEach((turno) => {

        mapaActualizados.set(
            String(getTurnoId(turno)),
            turno
        );

    });


    return turnosActuales.map((turnoActual) => {

        const idActual =
            String(getTurnoId(turnoActual));


        if (!mapaActualizados.has(idActual)) {

            return normalizarTurnoFront(
                turnoActual
            );

        }


        const turnoActualizado =
            mapaActualizados.get(idActual);


        return normalizarTurnoFront({

            ...turnoActual,

            ...turnoActualizado

        });

    });

};


const quitarTurnosPorIds = (
    turnosActuales = [],
    idsBorrados = []
) => {

    const idsComoString =
        idsBorrados.map(String);


    return turnosActuales.filter(
        (turnoActual) => {

            const idActual =
                getTurnoId(turnoActual);

            return !idsComoString.includes(
                String(idActual)
            );

        }
    );

};


const obtenerTurnosCreadosDesdePayload = (payload) => {

    if (Array.isArray(payload?.turnos_creados)) {

        return payload.turnos_creados;

    }


    if (Array.isArray(payload?.turnos)) {

        return payload.turnos;

    }


    if (
        payload?.turno &&
        payload.turno.estado !== 'BORRADO'
    ) {

        return [payload.turno];

    }


    return [];

};


const obtenerTurnosEditadosDesdePayload = (payload) => {

    if (
        Array.isArray(
            payload?.turnos_actualizados
        )
    ) {

        return payload.turnos_actualizados.filter(
            (turno) =>
                turno?.estado !== 'BORRADO'
        );

    }


    if (Array.isArray(payload?.turnos)) {

        return payload.turnos.filter(
            (turno) =>
                turno?.estado !== 'BORRADO'
        );

    }


    if (
        payload?.turno &&
        payload.turno.estado !== 'BORRADO'
    ) {

        return [payload.turno];

    }


    return [];

};


const obtenerIdsBorradosDesdePayload = (payload) => {

    if (Array.isArray(payload?.ids_borrados)) {

        return payload.ids_borrados;

    }


    if (
        Array.isArray(
            payload?.turnos_borrados
        )
    ) {

        return payload.turnos_borrados
            .map(getTurnoId)
            .filter(Boolean);

    }


    const idsDesdeTurnosActualizados = [];


    if (
        Array.isArray(
            payload?.turnos_actualizados
        )
    ) {

        payload.turnos_actualizados.forEach(
            (turno) => {

                if (turno?.estado === 'BORRADO') {

                    const idTurno =
                        getTurnoId(turno);


                    if (idTurno) {

                        idsDesdeTurnosActualizados.push(
                            idTurno
                        );

                    }

                }

            }
        );

    }


    if (Array.isArray(payload?.turnos)) {

        payload.turnos.forEach(
            (turno) => {

                if (turno?.estado === 'BORRADO') {

                    const idTurno =
                        getTurnoId(turno);


                    if (idTurno) {

                        idsDesdeTurnosActualizados.push(
                            idTurno
                        );

                    }

                }

            }
        );

    }


    if (
        idsDesdeTurnosActualizados.length > 0
    ) {

        return idsDesdeTurnosActualizados;

    }


    if (
        payload?.turno?.estado === 'BORRADO'
    ) {

        const idTurno =
            getTurnoId(payload.turno);


        return idTurno
            ? [idTurno]
            : [];

    }


    if (payload?.id_turno) {

        return [payload.id_turno];

    }


    if (payload?.id) {

        return [payload.id];

    }


    return [];

};


/*
====================================
REDUCER INFORMACIÓN DEL PACIENTE
====================================
*/

export default function solicitoInformacionReducer(
    state = initialState,
    action
) {

    switch(action.type) {


        /*
        ====================================
        CERRAR SESIÓN
        ====================================
        */

        case CERRAR_SESION:

            return {

                ...initialState

            };


        /*
        ====================================
        INFORMACIÓN GENERAL
        ====================================
        */

        case SOLICITO_INFORMACION_EJERCICIO_EXITO:

            return {

                ...state,

                info_DB:
                    action.payload.info_ejercicio,

                lista_usada:
                    action.payload.lista_utilizada

            };


        case SOLICITO_INFORMACION_PACIENTE_EXITO:

            return {

                ...state,

                lista_pacientes:
                    action.payload.lista_pacientes,

                lista_ejercicios_check:
                    action.payload.lista_ejercicios_check

            };


        case ACTUALIZAR_INFORMACION_PACIENTE_EXITO:

            return {

                ...state,

                lista_pacientes:
                    action.payload.lista_pacientes,

                lista_ejercicios_check:
                    action.payload.lista_ejercicios_check ??
                    state.lista_ejercicios_check

            };


        /*
        ====================================
        OBJETIVOS
        ====================================
        */

        case SOLICITAR_OBJETIVOS_EXITO:

            return {

                ...state,

                info_objetivos:
                    action.payload

            };


        case MODIFICAR_OBJETIVO_EXITO:

            return {

                ...state,

                info_objetivos:
                    action.payload

            };


        /*
        ====================================
        ANAMNESIS ESTRUCTURADA
        ====================================
        */

        case SOLICITO_ANAMNESIS_EXITO:

            return {

                ...state,

                info_anamnesis:
                    action.payload

            };


        /*
        ====================================
        ANAMNESIS - ENTREVISTA SEMIESTRUCTURADA
        ====================================
        */

        case SOLICITAR_ANAMNESIS_ENTREVISTA:

            return {

                ...state,

                info_anamnesis_entrevista:
                    null,

                anamnesis_entrevista_cargando:
                    true,

                anamnesis_entrevista_cargada:
                    false,

                anamnesis_entrevista_error:
                    null

            };


        case SOLICITAR_ANAMNESIS_ENTREVISTA_EXITO:

            return {

                ...state,

                info_anamnesis_entrevista:
                    action.payload,

                anamnesis_entrevista_cargando:
                    false,

                anamnesis_entrevista_cargada:
                    true,

                anamnesis_entrevista_error:
                    null

            };


        case SOLICITAR_ANAMNESIS_ENTREVISTA_ERROR:

            return {

                ...state,

                info_anamnesis_entrevista:
                    null,

                anamnesis_entrevista_cargando:
                    false,

                anamnesis_entrevista_cargada:
                    false,

                anamnesis_entrevista_error:
                    action.payload

            };


        case ALMACENAR_ANAMNESIS_ENTREVISTA:

            return {

                ...state,

                anamnesis_entrevista_guardando:
                    true,

                anamnesis_entrevista_error:
                    null

            };


        case ALMACENAR_ANAMNESIS_ENTREVISTA_EXITO:

            return {

                ...state,

                info_anamnesis_entrevista:
                    action.payload.entrevista,

                anamnesis_entrevista_cargando:
                    false,

                anamnesis_entrevista_cargada:
                    true,

                anamnesis_entrevista_guardando:
                    false,

                anamnesis_entrevista_error:
                    null

            };


        case ALMACENAR_ANAMNESIS_ENTREVISTA_ERROR:

            return {

                ...state,

                anamnesis_entrevista_guardando:
                    false,

                anamnesis_entrevista_error:
                    action.payload

            };


        /*
        ====================================
        ANAMNESIS - ADENDAS
        ====================================

        Conservamos el id_paciente de la
        consulta para no mostrar resultados
        de un paciente anterior si se cambia
        de paciente durante una petición.
        ====================================
        */

        case SOLICITAR_ADENDAS_ANAMNESIS:

            return {

                ...state,

                info_anamnesis_adendas: [],

                anamnesis_adendas_paciente_id:
                    action.payload.id_paciente,

                anamnesis_adendas_cargando:
                    true,

                anamnesis_adendas_cargadas:
                    false,

                anamnesis_adendas_error:
                    null

            };


        case SOLICITAR_ADENDAS_ANAMNESIS_EXITO:

            /*
            Si la respuesta pertenece a otro
            paciente, no reemplazamos los
            datos del paciente actual.
            */

            if (
                state.anamnesis_adendas_paciente_id !==
                action.payload.id_paciente
            ) {

                return state;

            }


            return {

                ...state,

                info_anamnesis_adendas:
                    action.payload.adendas,

                anamnesis_adendas_cargando:
                    false,

                anamnesis_adendas_cargadas:
                    true,

                anamnesis_adendas_error:
                    null

            };


        case SOLICITAR_ADENDAS_ANAMNESIS_ERROR:

            if (
                state.anamnesis_adendas_paciente_id !==
                action.payload.id_paciente
            ) {

                return state;

            }


            return {

                ...state,

                info_anamnesis_adendas: [],

                anamnesis_adendas_cargando:
                    false,

                anamnesis_adendas_cargadas:
                    false,

                anamnesis_adendas_error:
                    action.payload.error

            };


        /*
        ====================================
        GUARDAR NUEVA ADENDA
        ====================================
        */

        case ALMACENAR_ADENDA_ANAMNESIS:

            if (
                state.anamnesis_adendas_paciente_id !==
                action.payload.id_paciente
            ) {

                return state;

            }


            return {

                ...state,

                anamnesis_adendas_guardando:
                    true,

                anamnesis_adendas_error:
                    null

            };


        case ALMACENAR_ADENDA_ANAMNESIS_EXITO:

            if (
                state.anamnesis_adendas_paciente_id !==
                action.payload.id_paciente
            ) {

                return state;

            }


            /*
            El componente vuelve a consultar
            las adendas después del guardado.

            No agregamos una adenda inventada
            al listado de Redux.
            */

            return {

                ...state,

                anamnesis_adendas_guardando:
                    false,

                anamnesis_adendas_error:
                    null

            };


        case ALMACENAR_ADENDA_ANAMNESIS_ERROR:

            if (
                state.anamnesis_adendas_paciente_id !==
                action.payload.id_paciente
            ) {

                return state;

            }


            return {

                ...state,

                anamnesis_adendas_guardando:
                    false,

                anamnesis_adendas_error:
                    action.payload.error

            };


        /*
        ====================================
        HISTORIA CLÍNICA
        ====================================
        */

        case SOLICITAR_HISTORIA_CLINICA_EXITO:

        case MODIFICAR_HISTORIA_CLINICA_EXITO:

            return {

                ...state,

                info_historia_clinica:
                    action.payload

            };

        /*
        ====================================
        EXPORTACIÓN HISTORIA CLÍNICA
        ====================================
        */


        case SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES:


            return {

                ...state,

                historias_clinicas_exportables_cargando:
                    true,

                historias_clinicas_exportables_error:
                    null

            };


        case SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES_EXITO:


            return {

                ...state,

                info_historias_clinicas_exportables:

                    action.payload || {

                        scope:
                            null,

                        pacientes:
                            []

                    },

                historias_clinicas_exportables_cargando:
                    false,

                historias_clinicas_exportables_error:
                    null

            };


        case SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES_ERROR:


            return {

                ...state,

                info_historias_clinicas_exportables: {

                    scope:
                        null,

                    pacientes:
                        []

                },

                historias_clinicas_exportables_cargando:
                    false,

                historias_clinicas_exportables_error:
                    action.payload

            };

        /*
        ====================================
        PREPARAR EXPORTACIÓN HC
        ====================================
        */


        case PREPARAR_EXPORTACION_HISTORIA_CLINICA:


            return {

                ...state,

                preparacion_exportacion_hc:
                    null,

                preparacion_exportacion_hc_cargando:
                    true,

                preparacion_exportacion_hc_error:
                    null

            };


        case PREPARAR_EXPORTACION_HISTORIA_CLINICA_EXITO:


            return {

                ...state,

                preparacion_exportacion_hc:
                    action.payload,

                preparacion_exportacion_hc_cargando:
                    false,

                preparacion_exportacion_hc_error:
                    null

            };


        case PREPARAR_EXPORTACION_HISTORIA_CLINICA_ERROR:


            return {

                ...state,

                preparacion_exportacion_hc:
                    null,

                preparacion_exportacion_hc_cargando:
                    false,

                preparacion_exportacion_hc_error:
                    action.payload

            };
        
        /*
        ====================================
        EXPORTAR HISTORIAS CLÍNICAS
        ====================================
        */


        case EXPORTAR_HISTORIAS_CLINICAS:


            return {

                ...state,

                exportacion_historias_clinicas_cargando:
                    true,

                exportacion_historias_clinicas_error:
                    null,

                exportacion_historias_clinicas_resultado:
                    null

            };


        case EXPORTAR_HISTORIAS_CLINICAS_EXITO:


            return {

                ...state,

                exportacion_historias_clinicas_cargando:
                    false,

                exportacion_historias_clinicas_error:
                    null,

                exportacion_historias_clinicas_resultado:
                    action.payload

            };


        case EXPORTAR_HISTORIAS_CLINICAS_ERROR:


            return {

                ...state,

                exportacion_historias_clinicas_cargando:
                    false,

                exportacion_historias_clinicas_error:
                    action.payload,

                exportacion_historias_clinicas_resultado:
                    null

            };

        /*
        ====================================
        ACTIVIDADES
        ====================================
        */

        case SOLICITAR_ACTIVIDADES_EXITO:

        case ACTUALIZAR_INFO_ACTIVIDADES_EXITO:

            return {

                ...state,

                info_actividades:
                    action.payload

            };


        case SOLICITAR_ACTIVIDADES_AGENDADAS_EXITO:

            return {

                ...state,

                info_actividades_agendadas:
                    action.payload

            };


        /*
        ====================================
        RESULTADOS
        ====================================
        */

        case CONSULTAR_ACTIVIDADES_RESULTADOS_SUCCESS:

            return {

                ...state,

                info_resultadosDos:
                    action.payload

            };


        case CONSULTAR_EJERCICIOS_RESULTADOS_SUCCESS:

            return {

                ...state,

                info_resultados:
                    action.payload

            };


        /*
        ====================================
        TURNOS / CALENDARIO
        ====================================
        */

        case SOLICITO_INFORMACION_TURNOS_EXITO:

            return {

                ...state,

                info_calendario:
                    (
                        action.payload.info_calendario ||
                        []
                    )
                        .map(normalizarTurnoFront)
                        .filter(Boolean)

            };


        case CREAR_TURNO_EXITO: {

            const turnosCreados =
                obtenerTurnosCreadosDesdePayload(
                    action.payload
                );


            return {

                ...state,

                info_calendario:
                    agregarTurnosSinDuplicar(

                        state.info_calendario || [],

                        turnosCreados

                    )

            };

        }


        case REENVIAR_NOTIFICACION_TURNO_EXITO: {

            const turnosEditados =
                obtenerTurnosEditadosDesdePayload(
                    action.payload
                );


            return {

                ...state,

                info_calendario:
                    reemplazarTurnos(

                        state.info_calendario || [],

                        turnosEditados

                    )

            };

        }


        case EDITAR_TURNO_EXITO: {

            const turnosEditados =
                obtenerTurnosEditadosDesdePayload(
                    action.payload
                );


            const turnosCreados =
                obtenerTurnosCreadosDesdePayload(
                    action.payload
                );


            const idsBorrados =
                obtenerIdsBorradosDesdePayload(
                    action.payload
                );


            let infoCalendarioActualizada =
                reemplazarTurnos(

                    state.info_calendario || [],

                    turnosEditados

                );


            infoCalendarioActualizada =
                agregarTurnosSinDuplicar(

                    infoCalendarioActualizada,

                    turnosCreados

                );


            infoCalendarioActualizada =
                quitarTurnosPorIds(

                    infoCalendarioActualizada,

                    idsBorrados

                );


            return {

                ...state,

                info_calendario:
                    infoCalendarioActualizada

            };

        }


        case BORRAR_TURNO_EXITO: {

            const idsBorrados =
                obtenerIdsBorradosDesdePayload(
                    action.payload
                );


            return {

                ...state,

                info_calendario:
                    quitarTurnosPorIds(

                        state.info_calendario || [],

                        idsBorrados

                    )

            };

        }


        /*
        ====================================
        CAMBIO DE PACIENTE
        ====================================

        Limpiamos la entrevista y las adendas
        para evitar mostrar datos del paciente
        que estaba seleccionado anteriormente.
        ====================================
        */

        case ESTADO_PACIENTE_INITIAL:

            return {

                ...state,

                info_anamnesis: [],


                /*
                ENTREVISTA
                */

                info_anamnesis_entrevista:
                    null,

                anamnesis_entrevista_cargando:
                    false,

                anamnesis_entrevista_cargada:
                    false,

                anamnesis_entrevista_guardando:
                    false,

                anamnesis_entrevista_error:
                    null,


                /*
                ADENDAS
                */

                info_anamnesis_adendas: [],

                anamnesis_adendas_paciente_id:
                    null,

                anamnesis_adendas_cargando:
                    false,

                anamnesis_adendas_cargadas:
                    false,

                anamnesis_adendas_guardando:
                    false,

                anamnesis_adendas_error:
                    null,


                info_historia_clinica: [],

                info_objetivos: [],

                info_actividades_agendadas: [],

                info_resultados: []

            };


        case ESTADO_USUARIO_PACIENTE_INITIAL:

            return {

                ...state,

                info_DB: [],

                lista_pacientes: [],

                lista_ejercicios_check: [],

                lista_usada: [],

                info_anamnesis: [],


                /*
                ENTREVISTA
                */

                info_anamnesis_entrevista:
                    null,

                anamnesis_entrevista_cargando:
                    false,

                anamnesis_entrevista_cargada:
                    false,

                anamnesis_entrevista_guardando:
                    false,

                anamnesis_entrevista_error:
                    null,


                /*
                ADENDAS
                */

                info_anamnesis_adendas: [],

                anamnesis_adendas_paciente_id:
                    null,

                anamnesis_adendas_cargando:
                    false,

                anamnesis_adendas_cargadas:
                    false,

                anamnesis_adendas_guardando:
                    false,

                anamnesis_adendas_error:
                    null,


                info_objetivos: [],

                info_historia_clinica: [],

                info_actividades: [],

                info_resultados: [],

                info_calendario: []

            };


        /*
        ====================================
        REINICIAR EJERCICIO
        ====================================
        */

        case RESET_EJERCICIO:

        case BORRAR_INFO_DB:

            return {

                ...state,

                info_DB: []

            };


        /*
        ====================================
        MODIFICAR PACIENTES
        ====================================
        */

        case MODIFICAR_PACIENTES:

            return {

                ...state,

                lista_pacientes:
                    action.payload

            };


        case ALMACENAR_CHECK_EJERCICIO_EXITO:

            return {

                ...state,

                lista_ejercicios_check:
                    action.payload

            };


        /*
        ====================================
        ARCHIVAR / DESARCHIVAR PACIENTE
        ====================================
        */

        case CAMBIAR_ARCHIVADO_PACIENTE_EXITO:

            return {

                ...state,

                lista_pacientes:
                    state.lista_pacientes.map(
                        (paciente) => {


                            if (
                                paciente.id_paciente !==
                                action.payload.id_paciente
                            ) {

                                return paciente;

                            }


                            return {

                                ...paciente,

                                archivado:
                                    action.payload.archivado,

                                fecha_archivado:
                                    action.payload.fecha_archivado

                            };

                        }
                    )

            };


        /*
        ====================================
        ACCIÓN NO RECONOCIDA
        ====================================
        */

        default:

            return state;

    }

}